import { Route } from '@/app/router'

const Distribution = () => import('./index.vue')

export default new Route('/distributions/:id', Distribution).as('Dashboard:Distribution').permissions(['VIEW_OEM_DISTRIBUTION', 'OEM_ENABLED'])
